<template>
  <AppHeader header-scroll-variant />

  <div class="container flex-column-center">
    <h1 v-text="title" />
    <button
      class="proxify-btn proxify-btn-white proxify-btn-no-icon"
      @click="handleError"
    >
      Back to homepage
    </button>
  </div>

  <AppFooter />
</template>

<script setup>
const props = defineProps({
  error: {
    type: Object,
    default: () => ({ statusCode: 404 }),
  },
});
const titles = {
  410: 'Whoops! Page has been deleted',
  404: 'Whoops! Page not found',
};

const title = computed(() => titles[props.error.statusCode] || titles[404]);
const handleError = () => clearError({ redirect: '/' });
</script>

<style lang="scss" scoped>
.container {
  height: 60vh;
}

h1 {
  font-size: 24px;
}

a {
  color: black;
}
</style>
